/*
 *   Copyright (c) 2020 BuserNet Consulting LLC
 *   All rights reserved.
 */
import { Geolocation } from '@capacitor/geolocation';
import AppConst from '../../constants/app.constant';
import {
  setKeyValueInLocalStorage,
} from '../localstorage/setKeyValueInLocalStorage';
import { alertGeolocationPermissionIssue } from './alertGeolocationPermissionIssue';

const getCurrentLocationNative = async () => {
  const coordinates = await Geolocation.getCurrentPosition();
  setKeyValueInLocalStorage(AppConst.localstorageConf.geoLocationPermissionGiven, 3);
  // const locationData = {
  //   coords: {
  //     latitude: 37.774929,
  //     longitude: -122.419416,
  //   },
  // };
  return coordinates;
};

/**
 *
 * @returns {coords: {latitude, longitude}}
 */
const getCurrentLocation = async () => {
  try {
    const coordinates = await getCurrentLocationNative();
    return coordinates;
  } catch (ex) {
  /**
   * CODE
   * PERMISSION_DENIED: 1
   * POSITION_UNAVAILABLE: 2
   */
    console.log(ex);
    alertGeolocationPermissionIssue();
    const { code } = ex;
    setKeyValueInLocalStorage(AppConst.localstorageConf.geoLocationPermissionGiven, code || 1);
    return null;
  }
};

export { getCurrentLocation };
